import React from "react";

import { getGimsDepartment } from "../../../../redux/directoryMaintenance/structuralUnitsReducer/actionsStructuralUnits";
import { getGimsDepartmentAll } from "../../../../redux/actions";

import { STRUCTURAL_UNITS_COLUMNS } from "../../../../components/GeneralComponents/SearchTable/TablesColumns";

import GeneralSectionComponent from "../generalSectionComponent";
import StructuralUnitsModal from "./structuralUnitsModal/structuralUnitsModal";

const StructuralUnits = () => {
  return (
    <GeneralSectionComponent
      title="Структурные подразделения"
      dataFromStateSelector={(state) => state.dictionaryReducer.departmentAll}
      getActionAll={getGimsDepartmentAll}
      getAction={getGimsDepartment}
      headerColumns={STRUCTURAL_UNITS_COLUMNS}
      ModalComponent={StructuralUnitsModal}
      searchTableSize={15}
    />
  );
};

export default StructuralUnits;
